export enum RouterPromptFormat {
  Current = 'current',
  ActionResult = 'action-result',
  MinimalSummary = 'minimal-summary',
}
